<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-select v-model="company" :items="$store.getters['admin/companies']" item-value="idx" item-text="name" clearable :label="$t('fields.company')"/>
      </v-col>
      <v-col cols="3">
        <DateRange v-model="dates" />
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      class="transparent"
      :page.sync="currentPage"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:group.header="{group,headers,isOpen,toggle}">
        <td :colspan="headers.length">
          <v-btn icon @click="toggle">
            <v-icon>{{isOpen?'mdi-minus':'mdi-plus'}}</v-icon>
          </v-btn>
          {{$store.getters['admin/company'](group).name}}
        </td>
      </template>
      <template v-slot:item.company="{item}">{{$store.getters['admin/company'](item.company).name}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.amount="{item}">{{item.amount | currency}}</template>
      <template v-slot:item.remain="{item}">{{item.remain | currency}}</template>
    </v-data-table>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import DateRange from "@/components/DateRange.vue";

export default {
  name: "AdminFinance",
  mixins: [commonmixin],
  components: { DateRange },
  data() {
    return {
      headers: [
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.company"), value: "company" },
        { text: this.$t("fields.task"), value: "task" },
        { text: this.$t("fields.comment"), value: "comment" },
        { text: this.$t("fields.amount"), value: "amount", align: "right" },
        { text: this.$t("fields.remain"), value: "remain", align: "right" }
      ]
    };
  },
  methods: {
    loadData() {
      this.$api.getAdminFinances().then(response => {
        this.items = response;
      });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped></style>